import React from "react"
import Carousel from 'react-bootstrap/Carousel';
import { Row, Col } from 'react-bootstrap';

function Carousels() {
    return (
        <Carousel >
            <Carousel.Item className='dtcloud-bg margin-banner'>
                <Row className='container'>
                    <Col md='8' sm='12' className='content-text'>
                        <h1 className="content"></h1>
                        <p className="content-sub-text"></p>
                        {/* <button className="explore-button">Explore more</button> */}
                    </Col>
                </Row>
            </Carousel.Item>
            <Carousel.Item className='secure-bg margin-banner'>
                <Row className='container'>
                    <Col md='8' sm='12' className='content-text'>
                        <h1 className="content">Secure Enterprise Cloud</h1>
                        <p className="content-sub-text">Premium Secure Enterprise Cloud for most demanding customers.</p>
                        {/* <button className="explore-button">Explore more</button> */}
                    </Col>
                </Row>
            </Carousel.Item>
            <Carousel.Item className='managed-cloud-bg margin-banner'>
                <Row className='container'>
                    <Col md='8' sm='12' className='content-text'>
                        <h1 className="content">Superb Customer Support</h1>
                        <p className="content-sub-text">DETASAD 24x7x365 tech team are always available not only to support but also to assist you with admin tasks.</p>
                        {/* <button className="explore-button">Explore more</button> */}
                    </Col>
                </Row>
            </Carousel.Item>
            <Carousel.Item className='data-protection-bg margin-banner'>
                <Row className='container'>
                    <Col md='8' sm='12' className='content-text'>
                        <h1 className="content">Your Data Stays Protected In Saudi Arabia</h1>
                        <p className="content-sub-text">DETASAD ensures your data is well protected and stays with in country.</p>
                        {/* <button className="explore-button">Explore more</button> */}
                    </Col>
                </Row>
            </Carousel.Item>
            <Carousel.Item className='compliance-bg margin-banner'>
                <Row className='container'>
                    <Col md='8' sm='12' className='content-text'>
                        <h1 className="content">Compliance & Certification</h1>
                        <p className="content-sub-text">TUVIT, ISO27001, ISO9000, PCI-DSS, Red Hat CSSP, SAP</p>
                        <button className="explore-button">Explore more</button>                            </Col>
                </Row>
            </Carousel.Item>
            <Carousel.Item className='datacenter-bg margin-banner'>
                <Row className='container'>
                    <Col md='8' sm='12' className='content-text'>
                        <h1 className="content">Datacenter</h1>
                        <p className="content-sub-text">Level 3 extended certified by TUVIT as Trusted Site Infrastructure.</p>
                        {/* <button className="explore-button">Explore more</button> */}
                    </Col>
                </Row>
            </Carousel.Item>
        </Carousel>
    )
}

export default Carousels; 